import React, {useEffect} from "react";
import {createTheme} from "@material-ui/core/styles";
import {ThemeProvider} from "@material-ui/styles";
import URLSearchParams from "url-search-params";
import MomentUtils from "@date-io/moment";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";
import {Redirect, Route, Switch, useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {IntlProvider} from "react-intl";
import "assets/vendors/style";
import breachbitsTheme from "./themes/breachbitsBreachRiskTheme";
// import indigoTheme from "./themes/indigoTheme";
// import cyanTheme from "./themes/cyanTheme";
// import orangeTheme from "./themes/orangeTheme";
// import amberTheme from "./themes/amberTheme";
// import pinkTheme from "./themes/pinkTheme";
// import blueTheme from "./themes/blueTheme";
// import purpleTheme from "./themes/purpleTheme";
// import greenTheme from "./themes/greenTheme";
import AppLocale from "../lngProvider";
import {
  BREACHBITS,
    DARK_BREACHBITS,
  // AMBER,
  // BLUE,
  // CYAN,
  // DARK_AMBER,
  // DARK_BLUE,
  // DARK_CYAN,
  // DARK_DEEP_ORANGE,
  // DARK_DEEP_PURPLE,
  // DARK_GREEN,
  // DARK_INDIGO,
  // DARK_PINK,
  // DEEP_ORANGE,
  // DEEP_PURPLE,
  // GREEN,
  // INDIGO,
  // PINK
} from "constants/ThemeColors";
import SignIn from "./SignIn";
import SignInMFA from "./SignInMFAVerificationForm";
//TODO: include this wnen we allow self signup
// import SignUp from "./SignUp";
import {
  fetchAuthUserData,
  setInitUrl, setMfaSessionToken,
  setUserData,
  setUserRefreshToken, setUserRefreshTokenOfAdminDuringMasquerade,
  setUserToken,
  setUserTokenOfAdminDuringMasquerade,
  userSignOutByTimeout
} from "../actions/Auth";
import RTL from "util/RTL";
import {setDarkTheme, setThemeColor} from "../actions/Setting";
import AppLayout from "./AppLayout";
// import 'react-notifications-component/dist/theme.css'
import ChangePasswordForm from "./ChangePasswordForm";
import ResetPasswordForm from "./ResetPasswordForm";
import ConfirmEmailForm from "./ConfirmEmailForm";
import RegisterUserForm from "./RegisterUserForm";
import {fetchCustomers, setCustomerInView, setEntityInView} from "../actions";

//IDLE TIMEOUT
import { useIdleTimer } from 'react-idle-timer'
import {
  bbArrayOfActiveSubscriptions, bbDoesCustomerHaveAccessToSubscription,
  bbFindUserTagsByTagId,
  bbGetCustomHomepageUrl,
  isCurrentUserMemberOf
} from "../util/bbHelpers";
import SubscriptionNotActiveModal from "../components/customBreachBits/modals/SubscriptionNotActiveModal";
import ConfirmNewEntityForNewUserForm from "./ConfirmNewEntityForNewUserForm";
import RegisterMFAPage from "./RegisterMFAPage";
import ProductWalkThroughsAndTours from "./ProductTours/ProductWalkThroughsAndTours";
import OnboardingProgressModal from "../components/customBreachBits/OnboardingProgress/OnboardingProgressModal";
import 'react-notifications-component/dist/theme.css'
import {ReactNotifications} from "react-notifications-component";
// import asyncComponent from "../util/asyncComponent";

const RestrictedRoute = ({component: Component, token, ...rest}) =>
  <Route
    {...rest}
    render={props =>
      token
        ? <Component {...props} />
        : <Redirect
          to={{
            pathname: '/signin',
            state: {from: props.location}
          }}
        />}
  />;

const App = (props) => {
  const dispatch = useDispatch();
  const {themeColor, darkTheme, locale, isDirectionRTL} = useSelector(({settings}) => settings);
  const {token, initURL, authUser, refreshToken, tokenOfAdminDuringMasquerade, refreshTokenOfAdminDuringMasquerade, mfaSessionToken, hasGetUserBeenCalledAtLeastOnce, loadingAuthUser} = useSelector(({auth}) => auth);
  const isDarkTheme = darkTheme;
  const {match, location} = props;

  //core data
  const {customers, customerInView} = useSelector(({customer}) => customer);
  const customer = customers ? customers[customerInView] : null;
  const customerIdToUse = customers ? customerInView ? customerInView : null : null;
  const history = useHistory();
  const isAdmin = isCurrentUserMemberOf(authUser, "admin")

  const {entityInView, portfolios,} = useSelector(({breachrisk}) => breachrisk);

  const entities = portfolios
  && portfolios[customerInView]
      ? portfolios[customerInView].entities
      : null;

  const arrayOfActiveSubscriptions = bbArrayOfActiveSubscriptions(customer);
  const hasActiveSubscription = arrayOfActiveSubscriptions ? arrayOfActiveSubscriptions.length > 0 : false;

  const hasSubscriptionForPage = location.pathname.includes("Portfolio")
      ? bbDoesCustomerHaveAccessToSubscription(customer, 1)
      : location.pathname.includes("Business")
      ? bbDoesCustomerHaveAccessToSubscription(customer, 2)
          : hasActiveSubscription

  console.log("App.js ", "arrayOfActiveSubscriptions", arrayOfActiveSubscriptions, "hasActiveSubscription", hasActiveSubscription, "hasSubscriptionForPage", hasSubscriptionForPage);

  // const isBRBusinessCustomer = isCurrentUserMemberOf(authUser,"breachrisk");

  // const currentShares =
  //     portfolios
  //     && customerIdToUse
  //     && authUser
  //     && portfolios[customerIdToUse]
  //     && isBRBusinessCustomer
  //         ? portfolios[customerIdToUse].shares
  //         : null;

  // const pendingShareRequests = currentShares
  //     ? Object.values(currentShares).filter((share)=> share.is_active && share.requested_by && !share.approved)
  //     : null;

  // const hasPendingShareRequests = pendingShareRequests &&
  //     pendingShareRequests.length > 0

  // console.log("initURL on the app.js page", initURL, "& props.history.location.search", props.history.location.search);

  // const userMessage = props.history.location.search ? qs.parse(props.history.location.search, { ignoreQueryPrefix: true }).message : null;
  //
  // if(userMessage){
  //   console.log("found a usermessage on the redirect to addMFA")
  //   if(userMessage === 'success'){
  //     console.log("usermessage is success")
  //     showBBNotification(SUCCESS,
  //         <IntlMessages id={"event.userEmailVerified.title"}/>,
  //         <IntlMessages id={"event.userEmailVerified.detail"}/>,
  //         true)
  //   }else if(userMessage === 'verified') {
  //     console.log("usermessage is verified")
  //     showBBNotification(WARNING,
  //         <IntlMessages id={"event.userEmailVerifiedAlready.title"}/>,
  //         <IntlMessages id={"event.userEmailVerifiedAlready.detail"}/>,
  //         true)
  //   } else{
  //     console.log("usermessage is undefined")
  //     showBBNotification(DANGER,
  //         <IntlMessages id={"event.userEmailVerifiedAlready.title"}/>,
  //         <IntlMessages id={"event.userEmailVerifiedAlready.detail"}/>,
  //         true)
  //   }
  // }

  //at least once per app reload, call the /me call to update authUser
  if(!hasGetUserBeenCalledAtLeastOnce && !loadingAuthUser && token) {
    dispatch(fetchAuthUserData());
  }

  // const customHomePageTags = bbFindUserTagsByTagId(authUser, 52);
  // const hasCustomHomePage = customHomePageTags && customHomePageTags.length > 0 && customHomePageTags.details !== 0;

  const checkLocalTokenAndSetToState = () => {
    //if there is a local token, but no state token, set the state token to the local token
    const localToken = JSON.parse(localStorage.getItem('token'));
    if (localToken && !token) {
      console.warn("A local token was found, but the state token was not set.  Updating state token");
      dispatch(setUserToken(localToken))
    }

    //if there is a local refresh token, but no state refresk token, set the state token to the local token
    const localRefreshToken = JSON.parse(localStorage.getItem('refreshToken'))
    if (localRefreshToken && !refreshToken) {
      console.warn("A local refresh token was found, but the state refresh token was not set.  Updating state refresh token");
      dispatch(setUserRefreshToken(localRefreshToken));
    }

    //if there is a local authUser, but no state authUser, set the state authUser to the local authUser
    const localAuthUser = JSON.parse(localStorage.getItem('authUser'));
    // console.log("Checking authUser", authUser, "localAuthUser", localAuthUser)
    if (localAuthUser && !authUser) {
      console.warn("A local authUser was found, but the state authUser was not set.  Updating state authUser");
      dispatch(setUserData(localAuthUser))
    }

    //if there is a local tokenOfAdminDuringMasquerade, but no state tokenOfAdminDuringMasquerade, set the state token to the local token
    const localTokenOfAdminDuringMasquerade = JSON.parse(localStorage.getItem('tokenOfAdminDuringMasquerade'));
    if (localTokenOfAdminDuringMasquerade && !tokenOfAdminDuringMasquerade) {
      console.warn("A local tokenOfAdminDuringMasquerade was found, but the state token was not set.  Updating state tokenOfAdminDuringMasquerade");
      dispatch(setUserTokenOfAdminDuringMasquerade(localTokenOfAdminDuringMasquerade));
    }

    //if there is a local refreshTokenOfAdminDuringMasquerade, but no state refreshTokenOfAdminDuringMasquerade, set the state token to the local token
    const localRefreshTokenOfAdminDuringMasquerade = JSON.parse(localStorage.getItem('refreshTokenOfAdminDuringMasquerade'));
    if (localRefreshTokenOfAdminDuringMasquerade && !refreshTokenOfAdminDuringMasquerade) {
      console.warn("A local refreshTokenOfAdminDuringMasquerade was found, but the state token was not set.  Updating state tokenOfAdminDuringMasquerade");
      dispatch(setUserRefreshTokenOfAdminDuringMasquerade(localRefreshTokenOfAdminDuringMasquerade));
    }

    //if there is a local sessionToken for MFA, but no state token, set the state token to the local token
    const localMFASessionToken = JSON.parse(localStorage.getItem('mfaSessionToken'));
    if (localMFASessionToken && !mfaSessionToken) {
      console.warn("A local mfaSessionToken was found, but the state mfaSessionToken was not set.  Updating state mfaSessionToken.", localMFASessionToken);
      dispatch(setMfaSessionToken(localMFASessionToken));
    }

  }


  /*
  IDLE TIMEOUT
   */

  const handleOnIdle = event => {
    // console.log('user is idle', event)
    // console.log('last active', getLastActiveTime())
    // only time out if the user is in the app, not the signin page
    if (location.pathname !== '/signin' || authUser) {
      dispatch(userSignOutByTimeout(true));
    }
  }

  const handleOnActive = event => {
    // console.log('user is active', event)
    // console.log('time remaining', getRemainingTime())
  }

  const handleOnAction = (e) => {
    // console.log('user did something', e)
  }

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 15, //15 min timeout
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500
  })

  /*
  END IDLE TIMEOUT
   */

  useEffect(() => {
    checkLocalTokenAndSetToState();

    const isPartner = isCurrentUserMemberOf(authUser, "partner");
    const isAdmin =  isCurrentUserMemberOf(authUser, "admin");
    const isStaff = isCurrentUserMemberOf(authUser, "staff");

    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
    // if (initURL === '') {
    //   console.log("initURL is empty, setting to", props.history.location.pathname,initURL)
    //   dispatch(setInitUrl(props.history.location.pathname));
    // }
    const params = new URLSearchParams(props.location.search);
    if (params.has("theme-name")) {
      dispatch(setThemeColor(params.get('theme-name')));
    }
    if (params.has("dark-theme")) {
      dispatch(setDarkTheme());
    }

    if ((isPartner
        || isAdmin
        || isStaff
        || (authUser && authUser.customers.length > 1) //CIRT-3P case?
    )) {
      if (customers && params.has("clientID")) {
        dispatch(setCustomerInView(params.get("clientID")));
      }

      //if they are a partner, staff, or admin, append the clientID search param
      //
      // if(customers
      //     && !params.has("clientID")
      //     && customerInView
      // ) {
      //   //set the urlParameters
      //   params.set("clientID", customerInView)
      //   // console.log("getting params", params.get("clientID"));
      //   history.replace({
      //     search: params.toString(),
      //   })
      // }
    }

      //BreachRisk, set the entity in view
      if (entities && params.has("entityID")) {
        dispatch(setEntityInView(params.get("entityID")));
        // console.log("Entity in view is", entityInView);
      }


    //load the core data
    if (customers == null && authUser) {
      // console.log("customers is empty, fetching from App.")
      dispatch(fetchCustomers());
    }
  }, [dispatch, props.location.search, authUser, customers, portfolios, entities]);


  const getColorTheme = (themeColor, applyTheme) => {
    switch (themeColor) {
      case BREACHBITS: {
        applyTheme = createTheme(breachbitsTheme);
        break;
      }
      case DARK_BREACHBITS: {
        applyTheme = createTheme(breachbitsTheme);
        break;
      }
      default :
        createTheme(breachbitsTheme);
    }
    return applyTheme;
  };

  let applyTheme = createTheme(breachbitsTheme);
  if (isDarkTheme) {
    document.body.classList.add('dark-theme');
    applyTheme = createTheme(darkTheme)
  } else {
    applyTheme = getColorTheme(themeColor, applyTheme);
  }
  if (location.pathname === '/') {
    // console.group()
    // console.log("token is", token)
    // console.log("initURL is", initURL)
    // console.groupEnd()
    if (token === null) {

      /*  jfd**********22.Jan.20.15:38*****
       *   For MFA, this is where app is checking if user is logged in.
       *  before we totally kick the user out, let's check to see if they are an MFA
       *  and if they are, need to send them to the MFA verification login page.
           ********************** `--===<>==<>==C>-< */

        //jfd: check for a mfa session token.
        if (mfaSessionToken === null) {
          //they are not engaged in MFA - send to signin page.
          console.log("User not logged in and not in MFA verification step, redirecting to signin.")
          return (<Redirect to={'/signin'}/>);
        } else {
          //send to MFA verification login page
          console.log("User not logged in and mfaSessionToken is not null", mfaSessionToken, "Send to MFA, but also maybe send to signin? ")
          return (<Redirect to={'/signin'}/>);
        }

    } else if (
        initURL === ''
        || initURL === '/'
        || initURL === '/signin'
        || initURL === '/confirm'
        || initURL === '/addMFA'
        || initURL.startsWith("/confirm")
        || initURL.startsWith("/register")
        || initURL.startsWith("/MFA")
        || initURL.startsWith("/mfa")
        || initURL.startsWith("/addMFA")
        // || (!initURL.startsWith("/board/admin") && initURL.startsWith("/board"))
    ) {
        //first, check to see if they have a custom homepage set
        const customHomepageUrl = bbGetCustomHomepageUrl(bbFindUserTagsByTagId(authUser, 52));
        console.log("Checking for customHomePage", customHomepageUrl, "checking if authUser is set", authUser);
        if (customHomepageUrl) {
          //TODO: optimisitic set it for now, but if they change subscriptions might need to do some checking before sending them here?
          console.log("Custom Homepage is set. Redirecting to it.  ", customHomepageUrl, "initURL", initURL);
          return (<Redirect to={customHomepageUrl}/>);
        }else if(authUser && authUser.user && !authUser.user.is_activated){
          //user signed in, but email is not verified and mfa is not enabled send them to
          console.log("User signed in without mfa enabled and without verifying their email. Redirecting to /addMFA")
          return (<Redirect to={`/addMFA`}/>)
        } else if((authUser && authUser.user && authUser.user.is_activated)
              && (authUser && authUser.security && !authUser.security.mfa_enabled)){
            //user signed in, but email is not verified and mfa is not enabled send them to
            console.log("User signed in without mfa enabled but their email is verified. Redirecting to /addMFA")
            return (<Redirect to={`/addMFA`}/>);
        } else if((authUser && authUser.customers && Array.isArray(authUser.customers) && authUser.customers.length === 0) && !isAdmin){
          console.log("User signed in without any customers associated. Directing user to /confirmNew")
          return (<Redirect to={`/confirmNew`}/>);
        } else if(isCurrentUserMemberOf(authUser,"breachrisk_portfolio")) {
            console.log("BreachRisk™ Portfolio customer. Redirecting to portfolio page. initURL: ", initURL);
            return (<Redirect to={'/board/BreachRisk/Portfolio/Insights'}/>);
        } else if(isCurrentUserMemberOf(authUser,"breachrisk")) {
            console.log("BreachRisk™ for Business customer. Redirecting to Business page. initURL: ", initURL);
            return (<Redirect to={'/board/BreachRisk/Business/Score'}/>);
        } else if((initURL === '/MFA' || initURL.toLowerCase() === '/mfa' ) && mfaSessionToken){
          console.log("If the initurl has been set to mfa but they are all the way signed in, push to /")
          return(<Redirect to={`/board/settings/account`}/>)
        }else if((initURL === '/MFA' || initURL.toLowerCase() === '/mfa' )&& !mfaSessionToken){
          console.log("If the initurl has been set to mfa but they are not all the way signed in, go to sign in")
          return(<Redirect to={`/signin`}/>)
        }else {
            console.log("Redirecting to settings. initURL: ", initURL);
            return (<Redirect to={'/board/settings/account'}/>);
        }
      // } else if(mfaSessionToken) {
      //   console.log("MFA session in progress. Redirecting to MFA page");
      //   //Why would it redirect to /mfa if mfa is there? This is causing infinite loop when timed out and logging back in... I think?
      //   return (<Redirect to={'/MFA'}/>);
      } else {
        console.log("Redirecting to ", initURL);
        return (<Redirect to={initURL}/>);
      }
  } else if (props.history.location.pathname != '/signin' && initURL === '/MFA' && !mfaSessionToken && !token){
    console.log("MFA session token is null, sign in hasn't happened , going to signin page for mfaSessionToken. Pathname was ", props.history.location.pathname,props.history.location.search, initURL)
    return (<Redirect to={'/signin'}/>);
  } else if (initURL === '') {
    console.log("No initURL, using pathname. props.hisotyr.locaiotn.pathname is", props.history.location.pathname, "props.history.loation.serach is ", props.history.location.search, "initUrl is ", initURL)
    dispatch(setInitUrl(`${props.history.location.pathname}${props.history.location.search}`));
  }

  if (isDirectionRTL) {
    applyTheme.direction = 'rtl';
    document.body.classList.add('rtl')
  } else {
    document.body.classList.remove('rtl');
    applyTheme.direction = 'ltr';
  }

  const currentAppLocale = AppLocale[locale.locale];
  // console.log("in indexf file")
  // console.log("authUser is ", authUser);
  return (
              <ThemeProvider theme={applyTheme}>

            <MuiPickersUtilsProvider utils={MomentUtils}>
              <IntlProvider
                locale={currentAppLocale.locale}
                messages={currentAppLocale.messages}>
                <RTL>
                {/*<ProductWalkThroughsAndTours>*/}
                  <div className="app-main">
                    <ReactNotifications/>
                    {customer && !hasSubscriptionForPage && <SubscriptionNotActiveModal/>}
                    {/*{customer && authUser && <OnboardingProgressModal/>}*/}
                    {/*//TODO: removing progress dialog until can discuss with John on how to get it to only open on log in*/}
                    {/*{isBRBusinessCustomer && hasPendingShareRequests && <BRPendingRequestNotification/>}*/}
                    <ProductWalkThroughsAndTours>
                      <Switch>
                        {/*{authUser && !authUser.user.is_active &&*/}
                        {/*<RestrictedRoute token={token}*/}
                        {/*                 component={SignIn}/>*/}
                        {/*}*/}

                        {authUser && authUser.user.needs_password_reset &&
                            <RestrictedRoute token={token}
                                             component={ChangePasswordForm}/>
                        }
                        {/*{authUser && authUser.customers.length &&*/}
                        <RestrictedRoute path={`${match.url}board`} token={token}
                                         component={AppLayout}/>
                        <RestrictedRoute path={`${match.url}password`} token={token}
                                         component={ChangePasswordForm}/>
                        <RestrictedRoute path={`${match.url}confirmNew`}
                                         token={token}
                                         component={ConfirmNewEntityForNewUserForm}/>
                        <RestrictedRoute path={`${match.url}addMFA`}
                                         token={token}
                                         component={RegisterMFAPage}/>
                        <RestrictedRoute path={`${match.url}MFA`}
                                         token={mfaSessionToken}
                                         component={SignInMFA}/>
                        <Route path='/signin' component={SignIn}/>
                        {/*<Route path='/MFA' component={SignInMFA}/>*/}
                        <Route path='/resetpassword' component={ResetPasswordForm}/>
                        <Route path='/confirm' component={ConfirmEmailForm}/>
                        <Route path='/register' component={RegisterUserForm}/>
                        {/*<Route path='/signup' component={SignUp}/>*/}
                        {/*<Route component={asyncComponent(() => import("app/routes/extraPages/routes/404"))}/>*/}
                        {/*<Route path='/register' component={RegisterUserForm}/>*/}
                        <Redirect exact from={`*`} to={`/board/settings/account`}/>
                      </Switch>
                    </ProductWalkThroughsAndTours>
                  </div>
                {/*</ProductWalkThroughsAndTours>*/}
                </RTL>
              </IntlProvider>
            </MuiPickersUtilsProvider>
          </ThemeProvider>
  );
};


export default App;
